"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.themes = exports["default"] = void 0;
var _reactCssThemr = require("react-css-themr");
var _ContextMenu = _interopRequireDefault(require("./ContextMenu"));
// themes
require("./themes/DefaultTheme.css");
var DefaultTheme = {
  "menu": "DefaultTheme__menu___CnAD_",
  "button": "DefaultTheme__button___EmHyB",
  "disabled": "DefaultTheme__disabled___24MZi",
  "separator": "DefaultTheme__separator___3vo3a",
  "option": "DefaultTheme__option___15e-M",
  "menu-sibling": "DefaultTheme__menu-sibling___2pk-f",
  "menu-sibling-options": "DefaultTheme__menu-sibling-options___3rhbB",
  "menu-sibling-toggle": "DefaultTheme__menu-sibling-toggle___2EStP",
  "menu-sibling-state-is-open": "DefaultTheme__menu-sibling-state-is-open___HYT_R",
  "menu-sibling-popup-position-t-0": "DefaultTheme__menu-sibling-popup-position-t-0___M57B2",
  "menu-sibling-popup-position-l-1": "DefaultTheme__menu-sibling-popup-position-l-1___2RNhH",
  "menu-sibling-popup-position-r-1": "DefaultTheme__menu-sibling-popup-position-r-1___Jioze",
  "menu-sibling-popup-position-c-1": "DefaultTheme__menu-sibling-popup-position-c-1___1JfzJ",
  "menu-sibling-popup-position-b-0": "DefaultTheme__menu-sibling-popup-position-b-0___eO2XY",
  "menu-sibling-popup-position-c-0": "DefaultTheme__menu-sibling-popup-position-c-0___29QNv",
  "menu-sibling-anchor-position-t-0": "DefaultTheme__menu-sibling-anchor-position-t-0___3L9ha",
  "menu-sibling-anchor-position-b-0": "DefaultTheme__menu-sibling-anchor-position-b-0___2Dnic",
  "menu-sibling-anchor-position-c-0": "DefaultTheme__menu-sibling-anchor-position-c-0___3SRdn",
  "menu-sibling-anchor-position-l-1": "DefaultTheme__menu-sibling-anchor-position-l-1___X6pQ4",
  "menu-sibling-anchor-position-r-1": "DefaultTheme__menu-sibling-anchor-position-r-1___1HO4P",
  "menu-sibling-anchor-position-c-1": "DefaultTheme__menu-sibling-anchor-position-c-1___3QjiO",
  "menuSibling": "DefaultTheme__menu-sibling___2pk-f",
  "menuSiblingOptions": "DefaultTheme__menu-sibling-options___3rhbB",
  "menuSiblingToggle": "DefaultTheme__menu-sibling-toggle___2EStP",
  "menuSiblingStateIsOpen": "DefaultTheme__menu-sibling-state-is-open___HYT_R",
  "menuSiblingPopupPositionT0": "DefaultTheme__menu-sibling-popup-position-t-0___M57B2",
  "menuSiblingPopupPositionL1": "DefaultTheme__menu-sibling-popup-position-l-1___2RNhH",
  "menuSiblingPopupPositionR1": "DefaultTheme__menu-sibling-popup-position-r-1___Jioze",
  "menuSiblingPopupPositionC1": "DefaultTheme__menu-sibling-popup-position-c-1___1JfzJ",
  "menuSiblingPopupPositionB0": "DefaultTheme__menu-sibling-popup-position-b-0___eO2XY",
  "menuSiblingPopupPositionC0": "DefaultTheme__menu-sibling-popup-position-c-0___29QNv",
  "menuSiblingAnchorPositionT0": "DefaultTheme__menu-sibling-anchor-position-t-0___3L9ha",
  "menuSiblingAnchorPositionB0": "DefaultTheme__menu-sibling-anchor-position-b-0___2Dnic",
  "menuSiblingAnchorPositionC0": "DefaultTheme__menu-sibling-anchor-position-c-0___3SRdn",
  "menuSiblingAnchorPositionL1": "DefaultTheme__menu-sibling-anchor-position-l-1___X6pQ4",
  "menuSiblingAnchorPositionR1": "DefaultTheme__menu-sibling-anchor-position-r-1___1HO4P",
  "menuSiblingAnchorPositionC1": "DefaultTheme__menu-sibling-anchor-position-c-1___3QjiO"
};
require("./themes/DarkTheme.css");
var DarkTheme = {
  "menu": "DarkTheme__menu___3lz3h",
  "button": "DarkTheme__button___2M-AC",
  "disabled": "DarkTheme__disabled___KVrjU",
  "separatorButton": "DarkTheme__separatorButton___3vrlv"
};
require("./themes/LumeTheme.css");
var LumeTheme = {
  "menu": "LumeTheme__menu___Uqk_h"
};
require("../Popover/themes/DarkTheme.css");
var PopoverDarkTheme = {
  "popoverContent": "DarkTheme__popoverContent___urrUF"
};
DarkTheme.Popover = PopoverDarkTheme;
var themes = exports.themes = {
  DefaultTheme: DefaultTheme,
  DarkTheme: DarkTheme,
  LumeTheme: LumeTheme
};
var ThemedComponent = (0, _reactCssThemr.themr)(_ContextMenu["default"].displayName, themes.DefaultTheme)(_ContextMenu["default"]);
ThemedComponent.displayName = _ContextMenu["default"].displayName;
ThemedComponent.themes = themes;
var _default = exports["default"] = ThemedComponent;
//# sourceMappingURL=index.js.map